export default __webpack_public_path__ + "static/media/explosion.8814f5bf.mp3";